
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  inheritAttrs: true,
})
export default class AppCheckbox extends Vue {
  @Prop({})
  public readonly plain!: boolean;
}
